import type { CloudinaryAsset, SiteAssetDto, SiteAssetSlug } from '@igs/shared';
import { apiFetch } from '../../lib/api.js';

const PUBLIC_PATH = '/api/site-assets';
const ADMIN_PATH = '/api/admin/site-assets';

interface ListResponse {
  readonly items: readonly SiteAssetDto[];
}

export async function listPublicSiteAssets(): Promise<readonly SiteAssetDto[]> {
  return (await apiFetch<ListResponse>(PUBLIC_PATH)).items;
}

export async function listAdminSiteAssets(): Promise<readonly SiteAssetDto[]> {
  return (await apiFetch<ListResponse>(ADMIN_PATH)).items;
}

export interface UpsertSiteAssetBody {
  readonly asset: CloudinaryAsset;
  readonly alt: string;
}

export async function upsertSiteAsset(
  slug: SiteAssetSlug,
  body: UpsertSiteAssetBody,
): Promise<SiteAssetDto> {
  return apiFetch<SiteAssetDto>(`${ADMIN_PATH}/${slug}`, { method: 'PUT', body });
}

export async function deleteSiteAsset(slug: SiteAssetSlug): Promise<SiteAssetDto> {
  return apiFetch<SiteAssetDto>(`${ADMIN_PATH}/${slug}`, { method: 'DELETE' });
}
